import { createTelephoneDialogSave } from "#/admin/legacy/page-builder/telephone-dialog-save.js";
import { telephoneDialogData } from "#/admin/legacy/page-builder/telephone-dialog.js";

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    name: "phone-editor",

    templateId: "phone-editor-template",

    update: function (element, context) {
      var $element = jQuery(this.element);

      if (context && context.number) {
        $element.find(".preview").show();
        $element.find(".disable-inline").hide();
        $element.find(".phone-number-display").text(context.number);
      } else {
        $element.find(".preview").hide();
        $element.find(".disable-inline").show();
      }

      this.component.render();
    },

    bind: function (component) {
      var tool = this;
      var $element = jQuery(this.element);

      $element.on("click", ".edit", function (event) {
        event.preventDefault();
        tool.openPhoneDialog();
      });

      $element.on("click", ".remove", function (event) {
        event.preventDefault();
        tool.component.save({ id: "", number: "" });
        tool.update(tool.element, tool.component.context);
      });

      this.update(this.element, this.component.context);
    },

    unbind: function (element) {
      var $element = jQuery(this.element);
      $element.off("click");
    },

    openPhoneDialog: function () {
      var tool = this;
      var context = this.component.context || {};
      var blotData = { number: context.number || "", id: context.id || "" };

      var callTrackingInitialized = Sparkle.PageBuilder.CallTrackingManager.initialized;
      var template = Sparkle.HandlebarsTemplates["telephone-dialog"];
      var modal = new Sparkle.PageBuilder.Modal.Deprecated();

      updateModal(blotData.number);

      function updateModal(number, numberData) {
        numberData = numberData || {};

        if (callTrackingInitialized) {
          numberData = _.extend({}, Sparkle.PageBuilder.CallTrackingManager.find(number), numberData);
        } else {
          numberData = _.extend({}, { original_number: number }, numberData);
        }

        var templateData = telephoneDialogData(numberData, {
          callTrackingInitialized: callTrackingInitialized,
          workflowItems: Sparkle.PageBuilder.CallTrackingManager.workflow_items,
        });

        modal.setContent(template(templateData));
        Form.decorate(modal.dialog);
      }

      jQuery(modal.dialog).on("change", "[name=number]", function () {
        var numberInput = modal.dialog.querySelector("[name=number]");
        updateModal(numberInput.value);
      });

      jQuery(modal.dialog).on("change", "[name=tracking]", function () {
        var numberInput = modal.dialog.querySelector("[name=number]");
        var trackingInput = modal.dialog.querySelector("[name=tracking]");

        jQuery.post("/admin/phone_numbers/register.json?number=" + numberInput.value).then(
          function (data) {
            var numberData = {};
            if (callTrackingInitialized) {
              numberData = {
                original_number_id: data.id,
                original_local_number: data.local_number,
                wants_local_number: data.wants_local_number,
                enabled: trackingInput.checked,
              };
            }

            updateModal(data.number, numberData);
          },
          function (response) {
            var errorElement = modal.dialog.querySelector(".error");
            errorElement.innerHTML = response.responseJSON.errors;
          },
        );
      });

      if (blotData.id) {
        modal.setTitle("Edit Phone Number");
        modal.addSecondaryButton(
          "Remove phone number",
          function () {
            tool.component.save({ id: "", number: "" });
            tool.update(tool.element, tool.component.context);
            modal.remove();
          },
          "destroy",
        );
      } else {
        modal.setTitle("Select Phone Number");
      }

      modal.addPrimaryButton(
        "Done",
        createTelephoneDialogSave({
          dialog: modal.dialog,
          callTrackingInitialized: callTrackingInitialized,
          callTrackingManager: Sparkle.PageBuilder.CallTrackingManager,
          registerNumber: function (number) {
            return jQuery.post("/admin/phone_numbers/register.json?number=" + number);
          },
          save: function (data) {
            tool.component.save({ id: data.id, number: data.number });
            tool.update(tool.element, tool.component.context);
          },
          remove: function () {
            modal.remove();
          },
        }),
        true,
      );

      modal.show();

      var phoneInput = modal.dialog.querySelector("[name=number]");
      phoneInput.focus();
      phoneInput.setSelectionRange(phoneInput.value.length, phoneInput.value.length);
    },
  });
})();
